import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['x-auth-token'] = token;
  }
  return config;
});

export const login = (adminName, adminCode) => api.post('/api/admin/login', { adminName, adminCode });
export const logout = () => {
    localStorage.removeItem('token');
};

export const getAdminMe = () => api.get('/api/admin/me');
export const getUsers = () => api.get('/api/admin/users');
export const getUserDetails = (userId) => api.get(`/api/admin/users/${userId}`);
export const getUserTransactions = (userId) => api.get(`/api/admin/users/${userId}/transactions`);
export const getUserOrders = (userId) => api.get(`/api/admin/users/${userId}/orders`);
export const updateTransactionStatus = (txnId, txnStatus) => api.put(`/api/admin/transactions/${txnId}`, { txnStatus });
export const updateTransactionProofUrl = (txnId, paymentProof) => api.put(`/api/admin/transactions/${txnId}/proof-url`, { paymentProof });
export const getAdminSettings = () => api.get('/api/settings/bank-details');
export const updateAdminSettings = (settings) => api.put('/api/settings/bank-details', settings);
export const deleteTransaction = (txnId) => api.delete(`/api/admin/transactions/${txnId}`);
export const createTransaction = (userId, transactionData) => api.post(`/api/admin/users/${userId}/transactions`, transactionData);
export const updateUserDetails = (userId, userData) => api.put(`/api/admin/users/${userId}`, userData);
export const updateUserFunds = (userId, fundData) => api.put(`/api/admin/users/${userId}/funds`, fundData);
export const uploadAdminPaymentProof = (userId, transactionId, formData) => api.post(`/api/admin/users/${userId}/transactions/${transactionId}/proof`, formData, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const getUserFullDetails = (userId) => api.get(`/api/admin/users/${userId}/full-details`);
export const deleteUser = (userId) => api.delete(`/api/admin/users/${userId}`);

export const getUserNotifications = (userId) => api.get(`/api/admin/users/${userId}/notifications`);
export const createNotification = (userId, notificationData) => api.post(`/api/admin/users/${userId}/notifications`, notificationData);
export const updateNotification = (notificationId, notificationData) => api.put(`/api/admin/notifications/${notificationId}`, notificationData);
export const deleteNotification = (notificationId) => api.delete(`/api/admin/notifications/${notificationId}`);

// Support Tickets
export const getUserSupportTickets = (userId) => api.get(`/api/support/admin/user/${userId}`);
export const updateSupportTicket = (ticketId, ticketData) => api.put(`/api/support/admin/${ticketId}`, ticketData);
export const deleteSupportTicket = (ticketId) => api.delete(`/api/support/admin/${ticketId}`);


export default api;
